function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 3508.802h1920V0H0z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-120.138 -90.64)"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#2d250c",
  fillOpacity: 1,
  transform: "matrix(.35278 0 0 -.35278 131.323 99.09)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#2d250c",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  d: "M0 0c-.97-.969-.902-2.608-.902-2.608s1.639-.068 2.609.903c.969.968.9 2.606.9 2.606S.968.969 0 0"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#2d250c",
  fillOpacity: 1,
  transform: "matrix(.35278 0 0 -.35278 131.323 97.93)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#2d250c",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  d: "M0 0c-.97-.968-.902-2.607-.902-2.607s1.639-.068 2.609.901c.969.97.9 2.607.9 2.607S.968.968 0 0"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#2d250c",
  fillOpacity: 1,
  transform: "matrix(.35278 0 0 -.35278 131.323 100.25)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#2d250c",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  d: "M0 0c-.97-.969-.902-2.607-.902-2.607s1.639-.067 2.609.902c.969.969.9 2.607.9 2.607S.968.969 0 0"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#2d250c",
  fillOpacity: 1,
  transform: "matrix(.35278 0 0 -.35278 130.418 99.107)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#2d250c",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  d: "M0 0c.97-.969.903-2.607.903-2.607s-1.637-.068-2.607.902c-.97.969-.902 2.607-.902 2.607S-.968.969 0 0"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#2d250c",
  fillOpacity: 1,
  transform: "matrix(.35278 0 0 -.35278 130.418 97.946)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#2d250c",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  d: "M0 0c.97-.971.903-2.608.903-2.608s-1.637-.068-2.607.901C-2.674-.739-2.606.9-2.606.9S-.968.969 0 0"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#2d250c",
  fillOpacity: 1,
  transform: "matrix(.35278 0 0 -.35278 130.418 100.266)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#2d250c",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  d: "M0 0c.97-.969.903-2.608.903-2.608s-1.637-.068-2.607.902c-.97.969-.902 2.607-.902 2.607S-.968.968 0 0"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#2d250c",
  fillOpacity: 1,
  transform: "matrix(.35278 0 0 -.35278 130.446 97.354)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#2d250c",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  d: "M0 0c0 1.369 1.205 2.481 1.205 2.481S2.412 1.369 2.412 0c0-1.369-1.207-2.48-1.207-2.48S0-1.369 0 0"
})), /*#__PURE__*/React.createElement("g", {
  stroke: "#2d250c",
  strokeOpacity: 1,
  transform: "matrix(.35278 0 0 -.35278 126.958 94.733)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#2d250c",
  strokeDasharray: "none",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeOpacity: 1,
  strokeWidth: 1,
  d: "M0 0h-.006v.006s-7.103.011-8.525 0c-1.718-.01-2.111-1.193-2.125-1.242m-5.59-12.482c-.538-1.22-.163-1.891.244-2.239.278-.234.732-.404 1.083-.439a.525.525 0 01.088-.009l.002.004h.002v-.004H5.919m10.659 0h1.766c.758 0 1.162.318 1.366.582.522.678.286 1.643.256 1.75-.364 1.262-3.56 12.266-4.032 13.226-.336.678-1.04.858-1.402.858L11.723-.02"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#2d250c",
  fillOpacity: 1,
  transform: "matrix(.35278 0 0 -.35278 129.046 90.896)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#2d250c",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  d: "M0 0a4.455 4.455 0 004.451-4.449c0-2.828-2.794-8.878-4.451-8.878-1.578 0-4.452 6.223-4.452 8.878A4.456 4.456 0 000 0m0-14.051c2.356 0 5.173 6.89 5.173 9.602A5.18 5.18 0 010 .724a5.18 5.18 0 01-5.173-5.173c0-2.641 2.872-9.602 5.173-9.602"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#2d250c",
  fillOpacity: 1,
  transform: "matrix(.35278 0 0 -.35278 128.235 92.468)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#2d250c",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  d: "M0 0a2.302 2.302 0 002.299 2.296A2.3 2.3 0 004.596 0a2.301 2.301 0 00-2.297-2.298A2.302 2.302 0 000 0m5.076 0a2.78 2.78 0 01-2.777 2.777A2.782 2.782 0 01-.48 0a2.782 2.782 0 012.779-2.779A2.78 2.78 0 015.076 0"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.35278 0 0 -.35278 128.368 98.87)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fffbd0",
  fillOpacity: 1,
  fillRule: "nonzero",
  stroke: "none",
  d: "M0 0c-.697 0-1.266.618-1.266 1.377 0 .761.569 1.379 1.266 1.379.698 0 1.266-.618 1.266-1.379C1.266.618.698 0 0 0m-2.52 0c.393.312.648.81.648 1.377s-.255 1.066-.648 1.379h1.6a1.757 1.757 0 01-.647-1.379C-1.567.81-1.312.312-.92 0zm-3.439 0c.39.312.649.81.649 1.377s-.259 1.066-.649 1.379h1.6a1.758 1.758 0 01-.649-1.379c0-.567.257-1.065.649-1.377zm-2.186 1.377c0 .76.569 1.378 1.264 1.379.699 0 1.267-.618 1.267-1.379C-5.614.618-6.182 0-6.881 0c-.695.002-1.264.618-1.264 1.377M-21.639 0c-.695 0-1.263.618-1.263 1.377 0 .761.568 1.379 1.263 1.379h13.834a2.018 2.018 0 01-.166-.155c-.013-.014-.025-.031-.04-.044-.056-.07-.116-.141-.163-.219-.004-.003-.006-.008-.01-.015a1.809 1.809 0 01-.125-.249l-.022-.055a1.766 1.766 0 01-.087-.334 1.847 1.847 0 01-.029-.299v-.017a1.812 1.812 0 01.039-.358 1.66 1.66 0 01.099-.33c.037-.087.078-.171.125-.249.004-.007.006-.011.01-.015.047-.079.107-.149.163-.219.015-.013.027-.029.04-.045.054-.053.107-.105.166-.153zm.493 4.463c0 .761.567 1.377 1.265 1.377H-6.05a1.992 1.992 0 01-.165-.153c-.014-.016-.027-.032-.04-.045a1.708 1.708 0 01-.163-.217l-.008-.015a1.464 1.464 0 01-.126-.25 1.506 1.506 0 01-.1-.33c-.006-.018-.008-.04-.012-.061a1.93 1.93 0 01-.027-.298v-.015c.002-.102.01-.202.027-.299.004-.021.006-.042.012-.062a1.553 1.553 0 01.1-.329c.035-.087.075-.172.126-.249l.008-.016a1.5 1.5 0 01.163-.215c.013-.015.026-.032.04-.045.052-.056.107-.109.165-.155h-13.831c-.698 0-1.265.617-1.265 1.377m1.683 3.085c0 .76.567 1.378 1.265 1.378h13.833a1.64 1.64 0 01-.167-.156c-.014-.014-.024-.029-.035-.041a1.616 1.616 0 01-.169-.223l-.002-.004a1.481 1.481 0 01-.131-.261c-.008-.016-.014-.033-.022-.051a1.907 1.907 0 01-.079-.276l-.009-.057a1.652 1.652 0 010-.62c.004-.017.006-.036.009-.054a1.92 1.92 0 01.079-.277l.022-.052c.037-.09.078-.179.131-.259l.002-.003c.049-.081.105-.155.169-.225l.035-.041c.053-.055.107-.108.167-.156H-18.198c-.698 0-1.265.618-1.265 1.378m17.289 0c0-.76-.568-1.378-1.265-1.378-.023 0-.043.006-.07.01-.665.038-1.194.634-1.194 1.368 0 .733.529 1.331 1.194 1.37.027.002.047.008.07.008.697 0 1.265-.618 1.265-1.378m-4.215-3.085c0 .761.568 1.377 1.266 1.377.698 0 1.265-.616 1.265-1.377 0-.76-.567-1.377-1.265-1.377s-1.266.617-1.266 1.377m4.213-3.086C-2.176.618-2.742 0-3.439 0c-.699 0-1.264.618-1.264 1.377 0 .761.565 1.379 1.264 1.379.697 0 1.263-.618 1.263-1.379m-.497 4.463a1.756 1.756 0 01-.651-1.377c0-.567.26-1.067.651-1.377h-1.532c.392.31.65.81.65 1.377s-.258 1.066-.65 1.377h.766zm2.186-1.377c0-.76-.571-1.377-1.268-1.377-.698 0-1.264.617-1.264 1.377 0 .761.566 1.377 1.264 1.377.697 0 1.268-.616 1.268-1.377m.601-1.389v.012h-.949c.393.31.648.81.648 1.377 0 .898-.641 1.631-1.455 1.695v.012h-.878c.393.311.648.811.648 1.378 0 .942-.702 1.708-1.567 1.708h-14.759c-.865 0-1.569-.766-1.569-1.708 0-.567.257-1.067.648-1.378h-.762c-.866 0-1.568-.766-1.568-1.707 0-.567.258-1.067.647-1.377h-.837c-.864 0-1.566-.767-1.566-1.709 0-.94.702-1.707 1.566-1.707H-.144v.014C-.094-.318-.049-.33 0-.33c.866 0 1.568.767 1.568 1.707 0 .899-.64 1.632-1.454 1.697"
})), /*#__PURE__*/React.createElement("g", {
  fill: "#2d250c",
  fillOpacity: 1,
  stroke: "#2d250c",
  strokeOpacity: 1,
  transform: "matrix(.35278 0 0 -.35278 128.368 98.87)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#2d250c",
  fillOpacity: 1,
  stroke: "#2d250c",
  strokeDasharray: "none",
  strokeLinecap: "butt",
  strokeLinejoin: "miter",
  strokeMiterlimit: 10,
  strokeOpacity: 1,
  strokeWidth: 0.249,
  d: "M0 0c-.697 0-1.266.618-1.266 1.377 0 .761.569 1.379 1.266 1.379.698 0 1.266-.618 1.266-1.379C1.266.618.698 0 0 0zm-2.52 0c.393.312.648.81.648 1.377s-.255 1.066-.648 1.379h1.6a1.757 1.757 0 01-.647-1.379C-1.567.81-1.312.312-.92 0zm-3.439 0c.39.312.649.81.649 1.377s-.259 1.066-.649 1.379h1.6a1.758 1.758 0 01-.649-1.379c0-.567.257-1.065.649-1.377zm-2.186 1.377c0 .76.569 1.378 1.264 1.379.699 0 1.267-.618 1.267-1.379C-5.614.618-6.182 0-6.881 0c-.695.002-1.264.618-1.264 1.377zM-21.639 0c-.695 0-1.263.618-1.263 1.377 0 .761.568 1.379 1.263 1.379h13.834a2.018 2.018 0 01-.166-.155c-.013-.014-.025-.031-.04-.044-.056-.07-.116-.141-.163-.219-.004-.003-.006-.008-.01-.015a1.809 1.809 0 01-.125-.249l-.022-.055a1.766 1.766 0 01-.087-.334 1.847 1.847 0 01-.029-.299v-.017a1.812 1.812 0 01.039-.358 1.66 1.66 0 01.099-.33c.037-.087.078-.171.125-.249.004-.007.006-.011.01-.015.047-.079.107-.149.163-.219.015-.013.027-.029.04-.045.054-.053.107-.105.166-.153zm.493 4.463c0 .761.567 1.377 1.265 1.377H-6.05a1.992 1.992 0 01-.165-.153c-.014-.016-.027-.032-.04-.045a1.708 1.708 0 01-.163-.217l-.008-.015a1.464 1.464 0 01-.126-.25 1.506 1.506 0 01-.1-.33c-.006-.018-.008-.04-.012-.061a1.93 1.93 0 01-.027-.298v-.015c.002-.102.01-.202.027-.299.004-.021.006-.042.012-.062a1.553 1.553 0 01.1-.329c.035-.087.075-.172.126-.249l.008-.016a1.5 1.5 0 01.163-.215c.013-.015.026-.032.04-.045.052-.056.107-.109.165-.155h-13.831c-.698 0-1.265.617-1.265 1.377zm1.683 3.085c0 .76.567 1.378 1.265 1.378h13.833a1.64 1.64 0 01-.167-.156c-.014-.014-.024-.029-.035-.041a1.616 1.616 0 01-.169-.223l-.002-.004a1.481 1.481 0 01-.131-.261c-.008-.016-.014-.033-.022-.051a1.907 1.907 0 01-.079-.276l-.009-.057a1.652 1.652 0 010-.62c.004-.017.006-.036.009-.054a1.92 1.92 0 01.079-.277l.022-.052c.037-.09.078-.179.131-.259l.002-.003c.049-.081.105-.155.169-.225l.035-.041c.053-.055.107-.108.167-.156H-18.198c-.698 0-1.265.618-1.265 1.378zm17.289 0c0-.76-.568-1.378-1.265-1.378-.023 0-.043.006-.07.01-.665.038-1.194.634-1.194 1.368 0 .733.529 1.331 1.194 1.37.027.002.047.008.07.008.697 0 1.265-.618 1.265-1.378zm-4.215-3.085c0 .761.568 1.377 1.266 1.377.698 0 1.265-.616 1.265-1.377 0-.76-.567-1.377-1.265-1.377s-1.266.617-1.266 1.377zm4.213-3.086C-2.176.618-2.742 0-3.439 0c-.699 0-1.264.618-1.264 1.377 0 .761.565 1.379 1.264 1.379.697 0 1.263-.618 1.263-1.379zm-.497 4.463a1.756 1.756 0 01-.651-1.377c0-.567.26-1.067.651-1.377h-1.532c.392.31.65.81.65 1.377s-.258 1.066-.65 1.377h.766zm2.186-1.377c0-.76-.571-1.377-1.268-1.377-.698 0-1.264.617-1.264 1.377 0 .761.566 1.377 1.264 1.377.697 0 1.268-.616 1.268-1.377zm.601-1.389v.012h-.949c.393.31.648.81.648 1.377 0 .898-.641 1.631-1.455 1.695v.012h-.878c.393.311.648.811.648 1.378 0 .942-.702 1.708-1.567 1.708h-14.759c-.865 0-1.569-.766-1.569-1.708 0-.567.257-1.067.648-1.378h-.762c-.866 0-1.568-.766-1.568-1.707 0-.567.258-1.067.647-1.377h-.837c-.864 0-1.566-.767-1.566-1.709 0-.94.702-1.707 1.566-1.707H-.144v.014C-.094-.318-.049-.33 0-.33c.866 0 1.568.767 1.568 1.707 0 .899-.64 1.632-1.454 1.697z"
})));

var SvgTypeAll = function SvgTypeAll(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53.169,
    height: 39.86,
    viewBox: "0 0 14.068 10.546",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTypeAll, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/type_all.d3775e3d.svg";
export { ForwardRef as ReactComponent };